import { useState } from 'react'
import {
	Avatar,
	Box,
	IconButton,
	Paper,
	List,
	ListItem,
	ListItemText,
} from '@mui/material'
import InputCustom from './input/InputCustom'
import CloseIcon from '@mui/icons-material/Close'

export default function CustomUserSearch({
	members = [],
	selected = [],
	onSelect,
	onRemove,
	width = '100%',
	label = '',
	placeholder = 'Search User',
}) {
	const [query, setQuery] = useState('')
	const [showDropdown, setShowDropdown] = useState(false)

	const filtered = members.filter(
		(m) =>
			m.name.toLowerCase().includes(query.toLowerCase()) &&
			!selected.some((s) => s.id === m.id)
	)

	const handleSelect = (member) => {
		onSelect?.(member)
		setQuery('')
		setShowDropdown(false)
	}

	const handleRemove = (id) => {
		onRemove?.(id)
	}

	return (
		<Box sx={{ width }}>
			<Box
				sx={{
					font: 'Inter',
					fontWeight: 400,
					mb: 1,
					fontSize: '14px',
					lineHeight: '20px',
					color: '#658B9F',
				}}
			>
				{label}
			</Box>
			<InputCustom
				type="text"
				name="search_user"
				id="search_user"
				placeholder={placeholder}
				searchIcon={true}
				value={query}
				onChange={(e) => {
					setQuery(e.target.value)
					setShowDropdown(true)
				}}
			/>

			{showDropdown && query && filtered.length > 0 && (
				<Paper sx={{ mt: 5, position: 'absolute', zIndex: 10, width }}>
					<List>
						{filtered.map((member) => (
							<ListItem
								key={member.id}
								button
								onClick={() => handleSelect(member)}
							>
								<ListItemText primary={member.name} />
							</ListItem>
						))}
					</List>
				</Paper>
			)}

			<Box sx={{ display: 'flex', gap: 2, mt: 2, flexWrap: 'wrap' }}>
				{selected.map((member) => (
					<Box
						key={member.id}
						sx={{ position: 'relative', display: 'inline-flex' }}
					>
						<Avatar src={member.avatar} alt={member.name} />
						<IconButton
							size="small"
							sx={{
								position: 'absolute',
								top: -6,
								right: -6,
								bgcolor: 'black',
								color: 'white',
								width: 20,
								height: 20,
								'&:hover': { bgcolor: 'grey.700' },
							}}
							onClick={() => handleRemove(member.id)}
						>
							<CloseIcon fontSize="small" />
						</IconButton>
					</Box>
				))}
			</Box>
		</Box>
	)
}
